import React from 'react'

export default class ContactForm extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        name: '',
        surname: '',
        email: '',
        contactNumber: '',
        message: '',
        response: ''
      };
  
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    handleChange(event) {      
      const value = event.target.value;
      const property = event.target.name;

      this.setState({[property]: value});
    }
  
    handleSubmit(event) {      
      this.handleSendEmail(
        {
          to_name:"Admin", 
          name:this.state.name, 
          surname: this.state.surname,
          email:this.state.email, 
          contactNumber: this.state.contactNumber, 
          message: this.state.message
        })
      event.preventDefault();
    }

    handleSendEmail(variables){
      const emailTemplateId = "template_9k7gk57";
      window.emailjs.send(
        'service_6ovb63g', emailTemplateId,
        variables
      ).then(res=> {
        console.log("Email success.")
        this.resetForm();
        this.setState({'response': 'Your enquiry has been sent successfully. We will be in touch.'})

        setTimeout(()=>{
          this.setState({'response': ''})
        }, 5000)
      }).catch(err=> {
        this.resetForm();
        this.setState({'response': 'Your enquiry could not be sent at this stage, please try again later.'})
      })
    }

    resetForm(){
      this.setState({'name': ''})
      this.setState({'surname': ''})
      this.setState({'email': ''})
      this.setState({'contactNumber': ''})
      this.setState({'message': ''})
    }
  
    render() {
      return (
        <div>
          <h2>Get in touch with us</h2>
          <form onSubmit={this.handleSubmit}>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label for="name">Name  </label>
                  <input name="name" className="form-control" type="text" id="name" value={this.state.name} onChange={this.handleChange} />            
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label for="lastname">Lastname  </label>
                  <input name="surname" className="form-control" type="text" id="lastname" value={this.state.surname} onChange={this.handleChange} />            
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label for="contact">Contact Number  </label>
                  <input name="contactNumber" className="form-control" type="text" id="contact" value={this.state.contactNumber} onChange={this.handleChange} />            
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label for="email">Email  </label>
                  <input name="email" className="form-control" type="text" id="email" value={this.state.email} onChange={this.handleChange} />            
                </div>
              </div>
            </div>
            <div className="form-group">
                  <label for="message">Message  </label>
                  <textarea name="message" className="form-control message_text" type="text" id="message" value={this.state.message} onChange={this.handleChange} />            
              </div>

              <div className="form-group mt-3">
              <input className="btn btn-dark" type="submit" value="Submit" />
              <label className="response">{this.state.response}</label>
            </div>
            
          </form>
        </div>
      );
    }
  }